export default "__VITE_ASSET__3193b516__"